// isEditingTarget reports whether a keyboard event originates from a text
// editing context (cell editor, input, textarea, contenteditable). In that case
// the application-level Ctrl-Z/Ctrl-Y must NOT fire: the browser's native edit
// undo takes precedence while the user is typing in a cell.
export function isEditingTarget(target: EventTarget | null): boolean {
    const el = target as HTMLElement | null;
    if (!el) {
        return false;
    }
    const tag = el.tagName;
    return tag === "INPUT" || tag === "TEXTAREA" || el.isContentEditable === true;
}

// isInDialog reports whether a keyboard event originates from an open dialog
// (modal dialog, alert dialog, popover). The application-level Ctrl-Z/Ctrl-Y
// must NOT fire there: it would undo a record change of the grid hidden behind
// the dialog, while the user is working in the dialog. The body counts as in
// the dialog while one is open: the focus falls back to it when the backdrop
// is clicked or when the focused button of the dialog gets disabled.
export function isInDialog(target: EventTarget | null): boolean {
    if (!(target instanceof Element)) {
        return false;
    }
    if (target.closest('[role="dialog"], [role="alertdialog"]') !== null) {
        return true;
    }
    return target === target.ownerDocument.body
        && target.ownerDocument.querySelector('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]') !== null;
}
